import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';
import { langCodes } from './SupportLangs';

export const routing = defineRouting({
  locales: langCodes,

  // Used when no locale matches
  defaultLocale: 'en',
  localePrefix: 'always'
});


export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);